import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

export const initialEmailTemplateLocalState = {
  emailTemplate: {
    template_name: "",
    subject: "",
    signature_option: "",
    // salutation: "",
    category: "",
    lead_stage: "",
    template_from:"client",
    is_primary:false,
    default_sender_email: "",
    // disclaimer: "",
    body: "",
    links: [],
    signature: "",
    event: "",
    placeholders: [],
  },
};

export const emailSendLocalState = {
  emailSend: {
    templateId: "",
    to: "",
    cc: [],
    bcc: [],
    subject: "",
    body: "",
    send_to_all: false,
  },
};

const initialState = {
  newEmailTemplateLocal: initialEmailTemplateLocalState,
  newEmailSendLocal: emailSendLocalState,

  allEmailTemplates: [],
  isAddEmailTemplateSuccess: false,
  isAddEmailTemplateFailure: false,
  allSmsTemplates: [],
  isAddSmsTemplateSuccess: false,
  isAddSmsTemplateFailure: false,
  isDeleteTemplateSuccess: false,
  isSendEmailResponse: false,
  allEvents: [],
  leadStageWithPlaceholders: [],
};

export const emailTemplateSlice = createSlice({
  name: "EmailTemplate",
  initialState,
  reducers: {
    setNewEmailTemplateLocal: (state, action) => {
      state.newEmailTemplateLocal = {
        ...state.newEmailTemplateLocal,
        ...action.payload,
      };
    },

    resetNewEmailTemplateLocal: (state) => {
      state.newEmailTemplateLocal = initialEmailTemplateLocalState;
    },

    getAllEmailTemplatesAction: (state, { payload }) => {},
    setAllEmailTemplatesAction: (state, { payload }) => {
      console.log("payload", payload);
      state.allEmailTemplates = payload;
    },

    addEmailTemplateAction: (state, { payload }) => {},
    setAddEmailTemplateSuccessAction: (state, { payload }) => {
      state.isAddEmailTemplateSuccess = payload;
    },

    deleteEmailTemplateAction: (state, { payload }) => {},
    setDeleteEmailTemplateSuccessAction: (state, { payload }) => {
      state.isDeleteTemplateSuccess = payload;
    },

    updateEmailTemplateAction: (state, { payload }) => {},

    setAddEmailTemplateFailureAction: (state, { payload }) => {
      state.isAddEmailTemplateFailure = payload;
    },

    getAllSmsTemplatesAction: (state) => {},
    setAllSmsTemplatesAction: (state, { payload }) => {
      state.allEmailTemplates = payload;
    },

    addSmsTemplateAction: (state, { payload }) => {},
    setAddSmsTemplateSuccessAction: (state, { payload }) => {
      state.isAddSmsTemplateSuccess = payload;
    },
    setAddSmsTemplateFailureAction: (state, { payload }) => {
      state.isAddSmsTemplateFailure = payload;
    },

    getAllEventsAction: (state, { payload }) => {},
    setAllEventsAction: (state, { payload }) => {
      state.allEvents = payload;
    },

    sendEmailTemplateAction: (state, { payload }) => {},
    sendEmailTemplateResponseAction: (state, { payload }) => {
      state.isSendEmailResponse = payload;
    },

    setNewEmailSendLocal: (state, action) => {
      state.newEmailSendLocal = {
        ...state.newEmailSendLocal,
        ...action.payload,
      };
    },

    resetNewEmailSendLocal: (state) => {
      state.newEmailSendLocal = emailSendLocalState;
    },
    // get lead stage with placeholders

    getLeadStageWithPlaceholdersAction: (state) => {},
    setLeadStageWithPlaceholdersAction: (state, { payload }) => {
      state.leadStageWithPlaceholders = payload;
    },

    leadSendEmailTemplateAction: (state, { payload }) => {},
    setLeadSendEmailTemplateResponseAction: (state, { payload }) => {
      state.isSendEmailResponse = payload;
    },

    storageSendEmailTemplateAction:(state,{payload})=>{},
  },
});

const {
  setNewEmailTemplateLocal,
  resetNewEmailTemplateLocal,
  getAllEmailTemplatesAction,
  setAllEmailTemplatesAction,
  addEmailTemplateAction,
  setAddEmailTemplateSuccessAction,
  deleteEmailTemplateAction,
  setDeleteEmailTemplateSuccessAction,
  updateEmailTemplateAction,
  setAddEmailTemplateFailureAction,
  getAllSmsTemplatesAction,
  setAllSmsTemplatesAction,
  addSmsTemplateAction,
  setAddSmsTemplateSuccessAction,
  setAddSmsTemplateFailureAction,
  getAllEventsAction,
  setAllEventsAction,
  sendEmailTemplateAction,
  getLeadStageWithPlaceholdersAction,
  setLeadStageWithPlaceholdersAction,
  sendEmailTemplateResponseAction,
  setNewEmailSendLocal,
  resetNewEmailSendLocal,
  leadSendEmailTemplateAction,
  setLeadSendEmailTemplateResponseAction,
  storageSendEmailTemplateAction,
} = emailTemplateSlice.actions;

export {
  setNewEmailTemplateLocal,
  resetNewEmailTemplateLocal,
  getAllEmailTemplatesAction,
  setAllEmailTemplatesAction,
  addEmailTemplateAction,
  setAddEmailTemplateSuccessAction,
  deleteEmailTemplateAction,
  setDeleteEmailTemplateSuccessAction,
  updateEmailTemplateAction,
  setAddEmailTemplateFailureAction,
  getAllSmsTemplatesAction,
  setAllSmsTemplatesAction,
  addSmsTemplateAction,
  setAddSmsTemplateSuccessAction,
  setAddSmsTemplateFailureAction,
  getAllEventsAction,
  setAllEventsAction,
  sendEmailTemplateAction,
  sendEmailTemplateResponseAction,
  setNewEmailSendLocal,
  resetNewEmailSendLocal,
  getLeadStageWithPlaceholdersAction,
  setLeadStageWithPlaceholdersAction,
  leadSendEmailTemplateAction,
  setLeadSendEmailTemplateResponseAction,
  storageSendEmailTemplateAction
};

export default emailTemplateSlice.reducer;
